import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_requisition_hdr_entity_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    deposit_requisition_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    deposit_amount: fromDatatype.NumericDatatypeInterface;
    maturity_amount: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_calculation_logic: fromDatatype.VarcharDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    winner: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_deposit_requisition_hdr_entity_link_RowClass implements bl_fi_deposit_requisition_hdr_entity_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    deposit_requisition_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    deposit_amount: fromDatatype.NumericDatatypeInterface;
    maturity_amount: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_calculation_logic: fromDatatype.VarcharDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    winner: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
